import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { supabase } from '../../lib/supabase';

function parseHashParams(hash: string) {
  const h = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!h) return {};
  return h.split('&').reduce<Record<string, string>>((acc, pair) => {
    const [k, v] = pair.split('=');
    if (k) acc[decodeURIComponent(k)] = decodeURIComponent(v || '');
    return acc;
  }, {});
}

export default function AuthCallback() {
  const navigate = useNavigate();
  // מונע ריצה כפולה בסביבת פיתוח (React StrictMode) או עקב רנדר כפול
  const ranRef = useRef(false);

  useEffect(() => {
    (async () => {
      if (ranRef.current) {

        return;
      }
      ranRef.current = true;

      const href = window.location.href;
      const hasCode = href.includes('code=');
      const hasHashAccessToken = window.location.hash?.includes('access_token=');

      try {
        // 1) הפיכת ה-URL לסשן
        if (hasCode) {
          // PKCE
          const { data, error } = await supabase.auth.exchangeCodeForSession(href);

          if (error) throw error;

          // מנקה את ה-query params (code, state וכו')
          window.history.replaceState({}, document.title, '/auth/callback');
        } else if (hasHashAccessToken) {
          // Implicit
          const params = parseHashParams(window.location.hash);

          const access_token = params['access_token'];
          const refresh_token = params['refresh_token'];

          if (!access_token || !refresh_token) {
            throw new Error('Missing access_token or refresh_token in hash');
          }

          const { data, error } = await supabase.auth.setSession({
            access_token,
            refresh_token,
          });

          if (error) throw error;

          // מנקה את ה-hash מה־URL כדי שלא יישארו הטוקנים בכתובת
          window.history.replaceState({}, document.title, '/auth/callback');
        } else {
        }

        // 2) שליפת הסשן לאחר הטיפול ב-URL
        const { data: { session } } = await supabase.auth.getSession();

        // אם אין סשן — חזרה ל-login
        if (!session?.user) {
          toast.error('שגיאה בהשלמת ההתחברות');
          return navigate('/login', { replace: true });
        }

        // 3) בדיקה אם המשתמש קיים בטבלת האפליקציה (public.users)
        const { data: appUser, error: appUserErr } = await supabase
          .from('users')
          .select('id, business_id')
          .eq('id', session.user.id)
          .maybeSingle();

        // אם אין רשומת אפליקציה—המשתמש צריך להשלים הרשמה (לא עושים signOut!)
        if (!appUser) {
          toast((t) => (
            <span>
              אין לך עדיין חשבון ב-LoyalFlow. <b>השלם הרשמה כדי להיכנס!</b>
            </span>
          ), { icon: '✨' });
          return navigate('/register/business', { replace: true });
        }

        // 4) יש משתמש באפליקציה. אם אין לו עדיין עסק → לצעד הרישום של העסק
        if (!appUser.business_id) {
          toast('נשלים כמה פרטים אחרונים כדי לפתוח עסק 🎯');
          return navigate('/register/business', { replace: true });
        }

        // 5) הכל תקין → לדאשבורד
        return navigate('/dashboard', { replace: true });
      } catch (e: any) {

        toast.error('שגיאה בהשלמת ההתחברות');
        return navigate('/login', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-[100dvh] flex items-center justify-center">
      <div className="text-gray-600">מסיים התחברות…</div>
    </div>
  );
}
